/**
 * Path builders for apihub API routes.
 */

/** @param {string} template e.g. `/getInteractedCustomerDetail/projects/:id` */
/** @param {Record<string, string|number>} [params] */
export function buildPath(template, params = {}) {
  return Object.entries(params).reduce(
    (path, [key, value]) =>
      path.replace(`:${key}`, encodeURIComponent(String(value))),
    template,
  );
}

/** @param {string} path */
/** @param {Record<string, string|number|boolean|undefined|null>} [query] */
export function withQuery(path, query) {
  if (!query) return path;
  const qs = new URLSearchParams();
  Object.entries(query).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.set(k, String(v));
  });
  const s = qs.toString();
  return s ? `${path}?${s}` : path;
}
